module.exports = __webpack_public_path__ + "static/media/duplicate.0abdfa5e.svg";